import React, { CSSProperties, FC, ReactNode } from 'react';
import { Select, useTheme } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { useStyles } from '../styles';

interface Props {
  value: any;
  children: ReactNode;
  onChange: (value: any) => void;
  className?: string;
  style?: CSSProperties;
  border?: any;
  margin?: any;
  minWidth?: any;
}

export const SelectControl: FC<Props> = ({ value, onChange, children, style, border, margin, minWidth, className }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Select value={value} IconComponent={ExpandMore} onChange={onChange} className={`${classes.selectContainer} ${theme.direction === 'rtl' && classes.rtlIcon} ${className}`} style={{ ...style, border, margin, minWidth }}>
      {children}
    </Select>
  );
};
